// Extracted from `./mapUtils` so callers that only need coercion
// (notably home/Header/SearchForm) can pull just this helper without
// dragging the LatLng / LatLngBounds geo helpers and the rest of the
// map utilities onto the home chunk graph.
//
// Accepts an array of coord values that can be parsed as floats —
// e.g. `['37.81', '144.96']` from `getFiltersFromBounds`. Returns the
// values coerced to `number`. Items that aren't parseable surface as
// `NaN`; callers handle that downstream (the search-form path drops
// the params if any element is NaN by URLSearchParams accepting only
// finite numbers).
export type Coord = string | number
export const boundsToFloat = (b: readonly Coord[]): number[] =>
  b.map((v) => parseFloat(String(v)))
